import { useState } from 'react';
import { Link } from 'react-router-dom';

interface FAQ {
  q: string;
  a: string;
}

const faqs: FAQ[] = [
  {
    q: '爱丫爱丫影院的影视资源是免费的吗？',
    a: '是的，爱丫爱丫影院所有影视资源完全免费在线观看，无需注册、无需付费、无需会员。我们致力于为广大剧迷提供免费高清的观影体验。'
  },
  {
    q: '观看视频需要下载播放器吗？',
    a: '不需要。爱丫爱丫影院支持网页端直接播放，无需下载任何播放器或插件。只需要打开浏览器即可畅享高清影视内容。'
  },
  {
    q: '视频画质如何？支持哪些清晰度？',
    a: '我们提供1080P和4K高清画质，根据您的网络状况自动选择最佳清晰度。所有视频经过专业转码优化，确保流畅不卡顿。'
  },
  {
    q: '每天更新多少部剧集？',
    a: '我们每天都会同步更新最新上线的国产剧和韩剧，确保您可以第一时间看到最新剧集内容。热门剧集当日内即可更新。'
  },
  {
    q: '可以在手机上观看吗？',
    a: '当然可以。爱丫爱丫影院完美支持手机、平板、电脑等多种设备，自适应不同屏幕尺寸，随时随地畅享追剧乐趣。'
  },
  {
    q: '遇到播放问题怎么办？',
    a: '如果您遇到播放卡顿或无法播放的情况，可以尝试刷新页面或切换网络环境。如有其他问题，请通过页面底部的联系方式与我们取得联系，我们会尽快为您解决。'
  },
];

export default function About() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <main className="min-h-screen bg-background-50 pt-16">
      {/* Breadcrumb */}
      <nav className="px-4 md:px-8 py-4 max-w-[1280px] mx-auto" aria-label="面包屑导航">
        <ol className="flex items-center gap-2 text-sm">
          <li>
            <Link to="/" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
              首页
            </Link>
          </li>
          <li className="text-foreground-300">
            <i className="ri-arrow-right-s-line text-xs"></i>
          </li>
          <li>
            <span className="text-foreground-800 font-medium whitespace-nowrap">关于我们</span>
          </li>
        </ol>
      </nav>

      {/* Hero */}
      <section className="relative px-4 md:px-8 py-16 md:py-24">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinema%20theater%20with%20warm%20golden%20curtains%20and%20stage%20lights%2C%20elegant%20and%20luxurious%20interior%2C%20dramatic%20atmosphere%2C%20cinematic%20mood%2C%20professional%20photography&width=1600&height=500&seq=about-hero-bg&orientation=landscape"
            alt="关于爱丫爱丫影院"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-background-50/85"></div>
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-2xl bg-primary-500">
            <i className="ri-movie-2-line text-2xl text-background-950"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            关于爱丫爱丫影院
          </h1>
          <p className="text-base md:text-lg text-foreground-500 leading-relaxed">
            爱丫爱丫影院是一个专注于提供免费高清影视内容的在线平台。
            我们汇聚海量电视剧资源，涵盖最新国产剧、韩剧、美剧等各类热门剧集，
            致力于为广大剧迷打造最优质的在线观影体验。
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="px-4 md:px-8 py-10 md:py-14 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
          我们的优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-500/20">
              <i className="ri-4k-line text-xl text-primary-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-2">高清画质</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">提供1080P和4K超清画质，让您享受影院级观影体验，每个画面都清晰细腻。</p>
          </div>
          <div className="p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-accent-500/20">
              <i className="ri-speed-up-line text-xl text-accent-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-2">极速秒开</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">采用先进CDN加速技术，点击即播无需等待，告别缓冲烦恼，畅享流畅观影。</p>
          </div>
          <div className="p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-500/20">
              <i className="ri-global-line text-xl text-primary-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-2">海量资源</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">收录最新国产剧、韩剧、美剧等热门剧集，每日更新，追剧不停歇，资源全面覆盖。</p>
          </div>
          <div className="p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-accent-500/20">
              <i className="ri-smartphone-line text-xl text-accent-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-2">多端适配</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">完美适配手机、平板、电脑等多种设备，随时随地追剧，不受设备和地点限制。</p>
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="px-4 md:px-8 py-10 md:py-14 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 flex items-center gap-3" style={{ fontFamily: 'var(--font-heading)' }}>
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          品牌故事
        </h2>
        <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            爱丫爱丫影院诞生于对高品质影视内容的热爱与追求。我们深知，在忙碌的现代生活中，
            一部好剧能够带给人们放松和愉悦。因此，我们致力于打造一个免费、高清、流畅的影视平台，
            让每一位剧迷都能轻松找到心仪的剧集，享受极致的观影体验。
          </p>
          <p>
            我们的团队由一群热爱影视的年轻人组成，每天精心筛选和更新最新上线的热门剧集，
            确保平台内容的质量和时效性。从国产剧到韩剧，从都市情感到古装权谋，
            我们努力覆盖各种类型，满足不同观众的追剧需求。
          </p>
          <p>
            爱丫爱丫影院始终秉持"免费高清 · 流畅播放 · 秒开看剧"的理念，
            不断优化技术和服务，让每一位用户都能在这里找到属于自己的影视天地。
            电视剧大全，全集免费在线观看，尽在爱丫爱丫影院。
          </p>
        </div>
      </section>

      {/* Contact */}
      <section className="px-4 md:px-8 py-10 md:py-14 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 flex items-center gap-3" style={{ fontFamily: 'var(--font-heading)' }}>
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          联系我们
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="p-6 rounded-xl bg-background-100 flex items-start gap-4">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/20">
              <i className="ri-mail-line text-primary-400"></i>
            </div>
            <div>
              <p className="text-xs text-foreground-400 mb-1">电子邮箱</p>
              <p className="text-sm font-medium text-foreground-800">contact@aiyaaiya.com</p>
            </div>
          </div>
          <div className="p-6 rounded-xl bg-background-100 flex items-start gap-4">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-500/20">
              <i className="ri-wechat-line text-accent-400"></i>
            </div>
            <div>
              <p className="text-xs text-foreground-400 mb-1">微信公众号</p>
              <p className="text-sm font-medium text-foreground-800">爱丫爱丫影院</p>
            </div>
          </div>
          <div className="p-6 rounded-xl bg-background-100 flex items-start gap-4">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/20">
              <i className="ri-weibo-line text-primary-400"></i>
            </div>
            <div>
              <p className="text-xs text-foreground-400 mb-1">新浪微博</p>
              <p className="text-sm font-medium text-foreground-800">@爱丫爱丫影院</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="px-4 md:px-8 py-10 md:py-14 max-w-4xl mx-auto pb-16">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 flex items-center gap-3" style={{ fontFamily: 'var(--font-heading)' }}>
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          常见问题
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-xl bg-background-100 overflow-hidden">
              <button
                onClick={() => setOpenFAQ(openFAQ === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200 transition-colors duration-200"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-transform duration-300 ${openFAQ === i ? 'bg-primary-500 rotate-45' : 'bg-background-300'}`}>
                  <i className={`text-xs ${openFAQ === i ? 'text-background-950' : 'text-foreground-400'} ri-add-line`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openFAQ === i ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于爱丫爱丫影院",
            "description": "爱丫爱丫影院是一个专注于提供免费高清影视内容的在线平台。汇聚海量电视剧资源，涵盖最新国产剧、韩剧等各类热门剧集。",
            "url": typeof window !== 'undefined' ? window.location.href : '',
            "isPartOf": {
              "@type": "WebSite",
              "name": "爱丫爱丫影院",
              "url": "https://aiyaaiya.com/"
            },
            "about": {
              "@type": "Organization",
              "name": "爱丫爱丫影院",
              "description": "免费高清影视在线观看平台，提供电视剧大全、国产剧全集、韩剧全集等影视内容。",
              "url": "https://aiyaaiya.com/",
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "contact@aiyaaiya.com",
                "contactType": "customer service"
              }
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://aiyaaiya.com/" },
                { "@type": "ListItem", "position": 2, "name": "关于我们" }
              ]
            },
            "mainEntity": {
              "@type": "FAQPage",
              "mainEntity": faqs.map((faq, i) => ({
                "@type": "Question",
                "name": faq.q,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": faq.a
                }
              }))
            }
          })
        }}
      />
    </main>
  );
}